import { createCalendarViewContainer } from 'factories/CalendarView'
import selectors from 'selectors'
import actions from 'actions/jobs'
import Component from 'components/Jobs/CalendarView'

export default createCalendarViewContainer({ actions, selectors: selectors.jobs })(Component)
